import { TemplateStatus } from '../types/enums';
import { TEMPLATE_DRAFT_STATUS_TEXT, TEMPLATE_IN_USE_STATUS_TEXT } from '../constants/CommonConstants';

export const getTemplateStatusText = (status: TemplateStatus) => {
    switch (status) {
        case TemplateStatus.Error:
        case TemplateStatus.Development:
        case TemplateStatus.Generating:
        case TemplateStatus.Generated:
            return TEMPLATE_DRAFT_STATUS_TEXT;
        case TemplateStatus.Approved:
            return TemplateStatus[status];
        case TemplateStatus.Associated:
            return TEMPLATE_IN_USE_STATUS_TEXT;
        default:
            return status;
    }
} 

export const getStatusIdsFromText = (statusText: string) => {
    switch (statusText.toLowerCase()) {
        case 'draft':
            return [-1, 0, 1, 2];
        case 'approved':
            return [3];
        case 'in use':
            return [4];
        default:
            return [];
    }
}